import detectAdblock from '../utils/adblock';
import { log, logMethodCall } from '../utils/debug';

export function initPageBanners(context) {
  logMethodCall('initPageBanners');

  context.pageBanners = context.pageBanners || [];

  let storageManager;
  if (context.subscriptionManager && context.subscriptionManager.storageManager) {
    storageManager = context.subscriptionManager.storageManager;
  }

  (context.config.pageBannerNotifications || []).reduce((op, notification) => op.then((filteredNs) => new Promise((resolve) => {
    if (storageManager) {
      storageManager.getNotification(notification._id).then((dbNotification) => {
        if (dbNotification) {
          resolve(filteredNs);
        } else {
          resolve(filteredNs.concat(notification));
        }
      }).catch(() => {
        resolve(filteredNs.concat(notification));
      });
    } else {
      resolve(filteredNs.concat(notification));
    }
  })), Promise.resolve([])).then((filteredNotifications) => {
    if (filteredNotifications.length) {
      import('./index').then(({ default: PageBanner }) => {
        filteredNotifications.forEach((notification) => {
          const pageBanner = new PageBanner(notification, context.config, context.subscriptionManager, context.api);
          if (
            (!notification.scheduledAt || (notification.scheduledAt && notification.scheduledAt < new Date()))
            && (!notification.expiresAt || notification.expiresAt > new Date())
          ) {
            let show = true;
            if (show && notification.pageBannerMatchPath) {
              show = new RegExp(notification.pageBannerMatchPath).test(window.location.pathname);
            }
            if (show && notification.pageBannerNotMatchPath) {
              show = !(new RegExp(notification.pageBannerNotMatchPath).test(window.location.pathname));
            }
            if (show) {
              pageBanner.show();

              if (storageManager) {
                pageBanner.onClickCallback = () => storageManager.addNotification({
                  id: notification._id,
                  url: notification.url,
                  title: notification.title,
                  text: notification.text,
                  icon: notification.iconUrl,
                  media: notification.mediaUrl,
                  autoHide: notification.autoHide,
                  subscriptionId: '',
                  channelId: context.config.channelId,
                  scheduledAt: notification.scheduledAt,
                  createdAt: notification.createdAt,
                  expiresAt: notification.expiresAt,
                  clicked: 0,
                  markedAsDelivered: 1
                });
              }
            }
          }
          context.pageBanners.push(pageBanner);
        });
      });
    }
  });

  // adblock page banner
  if (!context.config.pageBannerAdblockEnabled) {
    return;
  }

  detectAdblock((detected) => {
    if (!detected) {
      return;
    }

    log.debug('AdBlock detected');

    import('./index').then(({ default: PageBanner }) => {
      const pageBanner = new PageBanner({
        id: 'adblockNotification',
        title: context.config.pageBannerAdblockTitle || '',
        text: context.config.pageBannerAdblockText || '',
        url: context.config.pageBannerAdblockUrl
      }, context.config, context.subscriptionManager, context.api);
      pageBanner.show();
    });
  });
}
